// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"0a3f56fb","236":"360fb8a2","259":"9784dbac","304":"6e2550f0","354":"b7aa041d","367":"8a971223","585":"1be8633e","739":"b3bac575","759":"ca3a721c","769":"291869e4","879":"e69fbf37","897":"38d61f64","961":"da55e400"}[chunkId] + ".js";
};